import React from 'react';
import Loadable from 'react-loadable';
import { RouteComponentProps } from 'react-router';

import BlankLoadingPage from '../../../../shared/components/BlankLoadingPage';
import { getQueryFromLocation } from '../../../../shared/utils/urls';
import { LoadableWidgetProviderSchedulingPage } from '../../../index';

const LoadableNewProviderSchedulingPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "newProviderSchedulingPage" */ './NewProviderSchedulingPage'),
  loading: () => <BlankLoadingPage />,
});

type Params = { id: string };

export default function NewProviderSchedulingPage(props: RouteComponentProps<Params>) {
  const { exp_widget_v2 } = getQueryFromLocation(props.location);

  if (exp_widget_v2 == null || exp_widget_v2 === '') {
    return <LoadableWidgetProviderSchedulingPage {...props} />;
  }
  return <LoadableNewProviderSchedulingPage {...props} />;
}
